import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity} from 'react-native';
export default class HMVideo extends Component {

    render() {
        const {path,item,style, text, icon, navigateParams, typeIcon,auto,noControls} = this.props;
        return (
            auto?
                <video
                    src={path ? path : (item.item && item.item.file ? item.item.file : (item.file?item.file:item))}
                    autoPlay
                    loop
                    muted
                    style={{
                        width: "100%",
                        height: "auto",
                        minHeight: "100%",
                        minWidth: "100%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }}
                />
                :
            <video width="100%" height="100%" controls  >
                <source src={path ? path : (item.item && item.item.file ? item.item.file : (item.file?item.file:item))} type="video/mp4"/>

            </video>


        );
    }


}
